import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../images/agent-portal-logo.svg';
import { enums } from '../../utils';

const AppHeader = () => {
  return (
    <div
      data-testid="connect-app-header"
      className="flex px-4 justify-center h-[60px]"
    >
      <div className="w-full flex justify-between items-center ml-6 mr-8">
        <Link className="p-3" to={enums.AppPaths.home}>
          <img src={Logo} alt="Unum Logo" />
        </Link>
        <Link
          to={enums.AppPaths.tasks}
          target="_blank"
          className="w-full max-w-[120px] "
        >
          <div className="w-full text-center bg-white border-[#0066B1] text-lg leading-[24px] border border-solid px-4 py-1 font-bold text-[#0066B1] rounded-full fs-unmask">
            Tasks
          </div>
        </Link>
      </div>
    </div>
  );
};

export default AppHeader;
